import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import VersionModal from "@/Modals/WebDataManagement/MasterData/Versions/Modal";
import { columns } from "./Columns";
import { versionsMasterDataApi } from "@/apis/apis";

export default function VersionsPage() {
  return (
    <MasterDataBaseTable
      label="Version"
      apiURL={versionsMasterDataApi}
      columns={columns()}
      ModalComponent={VersionModal}
      importData={BASE_IMPORT_DATA.VERSIONS}
      enableStatus={false}
      enableSortData={true}
    />
  );
}
